<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="content">
          <div class="is-size-3 mb-4">
            <font-awesome-icon icon="user-clock" />
          </div>
          <h1 class="title">Account Pending Approval</h1>
          <p class="subtitle">
            Your account does not have access yet.<br>
            Please contact an administrator to continue.
          </p>
          <p v-if="userEmail" class="mb-4">Signed in as {{ userEmail }}</p>
          <button class="button" @click="logout">
            <span>Logout</span>
            <span class="icon">
              <font-awesome-icon :icon="['fas', 'right-from-bracket']" />
            </span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/store'

export default {
  name: 'PendingApprovalView',
  setup() {
    const router = useRouter()
    const authStore = useAuthStore()

    const userEmail = computed(() => authStore.user?.email || '')

    const logout = async () => {
      try {
        await authStore.logout()
        router.push('/login')
      } catch (error) {
        console.error('Logout failed:', error)
      }
    }

    return {
      userEmail,
      logout
    }
  }
}
</script>
